/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils/index';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';

export const RecommendationCol = styled(Col)`
  ${(props) =>
    props.showPeek.small
      ? `@media ${props.theme.mediaQuery.smallOnly} {
    width: 125%;
  }`
      : ''}
  ${(props) =>
    props.showPeek.medium
      ? `@media ${props.theme.mediaQuery.mediumOnly} {
        width: 115%;
      }`
      : ''}

  ${(props) =>
    props.newRecommendationEnabled
      ? `@media ${props.theme.mediaQuery.large} {
      width: 100%;
      margin-left: 0;
    }`
      : ''}
`;

export default css`
  .item-container-inner {
    box-sizing: border-box;
    ${(props) =>
      props.inGridPlpRecommendation !== true
        ? `padding: 0 ${props.theme.spacing.APP_LAYOUT_SPACING.XXS};`
        : ''}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.inGridPlpRecommendation !== true && props.isNewPDPEnabled
          ? `
        width: ${props.isConfirmationPage && props.isSNJEnabled ? 'inherit' : '148px'};
        height: ${props.isRecommendationProductInfoEnabled ? `362px !important` : `278px`};
        margin: auto 3px;
        border-radius: 6px;
        border: solid 1px  ${props.theme.colors.PRIMARY.LIGHTGRAY};
        background-color: ${props.theme.colors.WHITE};
    `
          : ''}
      &.pdp {
        ${(props) =>
          props.isSNJEnabled ? `width: 118px; margin: auto 7px;padding:0; height:336px` : ''}
      }
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) => (props.inGridPlpRecommendation !== true ? 'padding: 0 12px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.inGridPlpRecommendation !== true && props.isNewPDPEnabled
          ? `
          width: 188px;
          height: 333px;
          margin: auto;
          border-radius: 6px;
          border: solid 1px  ${props.theme.colors.PRIMARY.LIGHTGRAY};
          `
          : ''}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        props.inGridPlpRecommendation !== true
          ? `padding: 0 ${props.theme.spacing.ELEM_SPACING.XXS};`
          : ``}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        props.inGridPlpRecommendation !== true && props.isNewPDPEnabled
          ? `
          width: 100%;
          height: 100%;
          margin: 0 ${props.theme.spacing.ELEM_SPACING.SM};
          padding: 0  ${props.theme.spacing.ELEM_SPACING.MED_1} ;
          border-radius: 6px;
          border: solid 1px  ${props.theme.colors.PRIMARY.LIGHTGRAY};
      `
          : ''}
      ${(props) => props.isVerticalRecommendationsEnabled && `height: 80% !important;`}
      ${(props) =>
        props.isVerticalRecommendationsEnabled &&
        `padding-top: 15px;border-radius: 6px;width:232px;`}
    }
  }

  .smooth-scroll-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    ${(props) => (props.isVerticalRecommendationsEnabled ? `height:auto;` : `height:100%;`)}
    ${(props) => props.isVerticalRecommendationsEnabled && `display:flex;flex-direction:column; `}
  }
  .smooth-scroll-list::-webkit-scrollbar {
    display: none;
  }
  /* stylelint-disable max-nesting-depth */
  /* stylelint-disable no-descending-specificity*/
  .smooth-scroll-list-item {
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    ${(props) =>
      props.isVerticalRecommendationsEnabled ? `height:auto; margin-bottom:15px;` : `height:100%;`}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => props.isNewPDPEnabled && `margin-right: 0px`}
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) => props.isNewPDPEnabled && `padding-left: 4px;`}
    }
    ${(props) =>
      props.page === Constants.RECOMMENDATIONS_PAGES_MAPPING.OUTFIT ? 'width: 33%;' : ''}
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.isNoResponseRecommendation ? `list-style-type: none;` : '')}
    }
    figure {
      ${(props) => props.isVerticalRecommendationsEnabled && `height: 190px;`}
    }
    .item-container-inner {
      ${(props) => props.isVerticalRecommendationsEnabled && `width: 195px;`}
    }
  }
  .smooth-scroll-list-item:first-child {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) => props.isNewPDPEnabled && `padding-left: 30px;`}
    }
  }
  .slick-track {
    display: flex;
  }
  .recommendations-section-col {
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      ${(props) =>
        props.isPDP && props.isRecommendationMarginEnabled ? 'margin-left: 34px; width: 95%;' : ''};
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) => props.isVerticalRecommendationsEnabled && `margin:0`}
      ${(props) =>
        props.isPDP && props.isRecommendationMarginEnabled ? 'margin-left: 40px; width: 96%;' : ''};
    }
  }

  .recommendations-section-home{
    width:100%;
    margin:0;
  }
  .recommendations-header {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: 900;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    ${(props) => (props.isNewPDPEnabled ? 'text-transform:uppercase;' : '')}
    margin: ${(props) =>
      props.newRecommendationEnabled
        ? `12px 0 12px 14px;`
        : `0 0 ${props.theme.spacing.MODULE_SPACING.MED} 0`};
    ${(props) => props.newRecommendationEnabled && 'font-size: 14px;'}
    ${(props) =>
      props.newRecommendationEnabled &&
      `border-top: 7px solid ${props.theme.colorPalette.gray[300]};`}
    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) => props.isVerticalRecommendationsEnabled && `margin:0 0px 10px 72px !important`}
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => props.isNewPDPEnabled && `border-top: 0px`}
    }
    ${(props) =>
      props.newRecommendationEnabled && `margin: ${props.theme.spacing.ELEM_SPACING.SM} 0;`}
    ${(props) =>
      props.newRecommendationEnabled &&
      `padding: ${props.theme.spacing.ELEM_SPACING.SM} 0 0 ${props.theme.spacing.ELEM_SPACING.MED};`}
  }
  .product-image-container {
    overflow: hidden;
    position: relative;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: ${(props) =>
        props.isNewPDPEnabled && !props.page === Constants.RECOMMENDATIONS_PAGES_MAPPING.OUTFIT
          ? `300px`
          : `352px`};
    }
  }
  .recommendation-cta-container {
    text-align: center;
    margin-top: 16px;
  }

  .price-only {
    .slick-arrow {
      top: 40%;
    }
  }

  .no-carousel-container {
    display: flex;
    justify-content: center;
    ul {
      width: 149px;
    }
  }

  .recommendations-container-new {
    padding: 0px;
    .recommendations-header {
      ${(props) =>
        props.isNoResponseRecommendation
          ? `  font-family: Nunito;
      font-size: 16px;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      margin: 0;
      line-height: 1.25;
      letter-spacing: 0.57px;
      text-align: left;`
          : ''}
    }
    ${(props) =>
      `border-right: 7px solid ${props.theme.colorPalette.gray[300]};
     border-top: ${props.theme.spacing.ELEM_SPACING.XS_1} solid
     ${props.theme.colorPalette.gray[300]};
     border-bottom: ${props.theme.spacing.ELEM_SPACING.XS_6} solid
     ${props.theme.colorPalette.gray[300]};
     `};
    ${(props) =>
      `border-left: 7px solid ${props.theme.colorPalette.gray[300]};
     padding-bottom: 20px;
     `};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0px 0px 24px;
      ${(props) =>
        props.isConfirmationPage && props.isSNJEnabled && props.isNewPDPEnabled && `border: unset;`}
      ${(props) => (props.isNewPDPEnabled ? `background-color: ${props.theme.colors.WHITE};` : ``)}
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      border: unset;
      padding: 24px 0px 32px;
      ${(props) => props.isVerticalRecommendationsEnabled && `padding: 9px 0px 32px;`}
      ${(props) =>
        `border-bottom: ${props.theme.spacing.ELEM_SPACING.XXXS} solid
          ${props.theme.colorPalette.gray[300]}
        padding: 0 10px;
        `}
    }

    .slick-slide > div,
    .slick-slide > div > ul {
      height: 100%;
      ${(props) => (props.isNoResponseRecommendation ? `list-style-type: none;` : '')}
    }

    @media ${(props) => props.theme.mediaQuery.desktop} {
      .container-price p {
        ${(props) => props.isVerticalRecommendationsEnabled && `font-size: 15px;`}
      }

      .container-price span {
        ${(props) => props.isVerticalRecommendationsEnabled && `font-size: 12px;`}
      }
    }
    .added-to-bag {
      border-radius: 6px;
      background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
      color: ${(props) => props.theme.colors.WHITE};
      ${(props) => props.isNewPDPEnabled && `margin-bottom: 14px;`}
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        ${(props) => props.isNewPDPEnabled && `padding: 11px 15px;`}
      }
      @media ${(props) => props.theme.mediaQuery.desktop} {
        ${(props) =>
          props.isVerticalRecommendationsEnabled ? `padding: 10px 15px;font-size: 12px;` : ''}
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        ${(props) =>
          props.isRecommendationProductInfoEnabled
            ? `
            margin-bottom: 4px !important;
            margin-top: 0px;
       `
            : ``}
      }
    }
    .slick-list {
      display: flex;
    }
    .slick-list .slick-track {
      display: flex;
      @media ${(props) => props.theme.mediaQuery.medium} {
        ${(props) => (props.isSNJEnabled && props.isNewPDPEnabled ? `width: auto !important;` : '')}
      }
    }
  }

  .recommendations-container {
    .slick-slide > div,
    .slick-slide > div > ul {
      height: 100%;
    }
    .added-to-bag {
      background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
      color: ${(props) => props.theme.colors.WHITE};
      ${(props) => (props.spcBag ? `border-radius: 6px;` : '')}
      ${(props) => props.isNewPDPEnabled && `margin-bottom: 14px;`}
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
    .slick-list {
      display: flex;
    }
    .slick-list .slick-track {
      display: flex;
      width: auto;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 16px 0px 24px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 24px 0px 32px;
    }
  }
  .recommendations-container-home{
    padding:0px !Important;
    border:0;
  }

  &.recommendations-tile {
    border-radius: 10px;
    background: ${(props) => props.theme.colorPalette.white};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.isNewPDPEnabled
          ? `
          background: ${props.theme.colors.PRIMARY.PALEGRAY};
     `
          : ``}
    }
    .slick-arrow {
      z-index: ${(props) => props.theme.zindex.zPLPFilterDropDown};
      top: 30%;
      transform: inherit;
    }
  }

  .moduleP-variation {
    .slick-arrow {
      top: 25%;
    }
  }

  .recommendation-cta {
    width: 225px;
  }

  .slick-slide li {
    margin: 0;
  }

  .slick-slide {
    ul li {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
  .slick-slide .item-container-inner {
    width: 100%;
    ${(props) => (props.isNoResponseRecommendation ? `width: 95% ;` : '')}
  }

  .accordion-recommendation {
    ${(props) =>
      !props.isNewPDPEnabled && ` border-top: 7px solid ${props.theme.colorPalette.gray[300]};`}
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0 0
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    ${(props) =>
      !props.isNewPDPEnabled &&
      `background: transparent url('${getIconPath(
        'up_arrow_toggle',
        props
      )}') no-repeat right 19px bottom 7px;`}
    text-transform: uppercase;
    display: block;
    width: 100%;
    justify-content: left;
    align-items: center;
    text-align: left;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      ${(props) =>
        props.isNewPDPEnabled &&
        ` margin: ${props.theme.spacing.ELEM_SPACING.SM} ${props.theme.spacing.ELEM_SPACING.SM};`}
    }
  }

  .recommendation-height-toggle {
    background: transparent url('${(props) => getIconPath('up_arrow_toggle', props)}') no-repeat
      center;
    height: 30px;
  }

  .small-recos-height {
    background: transparent url('${(props) => getIconPath('down_arrow_toggle', props)}') no-repeat
      center;
  }

  .recommendations-section-row {
    overflow: hidden;
    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) =>
        props.isPDP && props.isRecommendationMarginEnabled && 'overflow: unset !important;'}
    }
    ${(props) => props.isVerticalRecommendationsEnabled && `width:300px;overflow-y:auto;`}
  }

  .tcp_carousel_wrapper .slick-slider.tcp_carousel.slick-initialized {
    background-color: unset;
    margin: 0px;
    border: none;
  }
  .tcp_carousel_wrapper .slick-slide div {
    padding: 0px !important;
  }
  .tcp_carousel_wrapper .slick-slide .item-container-inner {
    padding: 0px 8px 4px !important;
    @media ${(props) => props.theme.mediaQuery.small} {
      ${(props) =>
        props.isRecommendationProductInfoEnabled
          ? `
          padding-bottom: 0px !important;
     `
          : ``}
    }
  }
  .recommendations-section-col .slick-prev {
    top: 28% !important;
    border: 0px !important;
    left: -68px !important;
    box-shadow: none;

    @media ${(props) => props.theme.mediaQuery.xlarge} {
      ${(props) => props.isPDP && props.isRecommendationMarginEnabled && 'left: -32px !important;'}
    }

    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) => props.isPDP && props.isRecommendationMarginEnabled && 'left: -24px !important;'}
    }
  }
  .recommendations-section-col .slick-next {
    top: 28% !important;
    border: 0px !important;
    right: -68px !important;
    margin: 0px;
    box-shadow: none;

    @media ${(props) => props.theme.mediaQuery.xlarge} {
      ${(props) => props.isPDP && props.isRecommendationMarginEnabled && 'right: -32px !important;'}
    }

    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) => props.isPDP && props.isRecommendationSidebar && 'right: -66px !important;'}
      ${(props) => props.isPDP && props.isRecommendationMarginEnabled && 'right: -24px !important;'}
    }
  }
  .small-recos-height-val + .recommendations-section-row {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 70px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      height: 70px;
    }
    height: auto;
  }

  .moduleO-variation {
    margin-top: 5px;
  }
  .carousel-min-height-bag{
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: ${(props) => (props.isRecommendationProductInfoEnabled ? `323px;` : `250px;`)};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-height: ${(props) => (props.isRecommendationProductInfoEnabled ? `368px;` : `291px;`)};
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      min-height: ${(props) => (props.isRecommendationProductInfoEnabled ? `360px;` : `291px;`)};
    }
  }
  .carousel-min-height-emptybag{
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: ${(props) => (props.isRecommendationProductInfoEnabled ? `503px;` : `437px;`)};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      min-height: ${(props) => (props.isRecommendationProductInfoEnabled ? `368px;` : `298px;`)};

    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      min-height: ${(props) => (props.isRecommendationProductInfoEnabled ? `359.5px;` : `290px;`)};
    }
  }
  .show-accordion-toggle {
    ${(props) =>
      !props.isNewPDPEnabled &&
      `background: transparent url('${getIconPath(
        'down_arrow_toggle',
        props
      )}') no-repeat right 19px bottom 7px;`}
  }

  .show-accordion-toggle ~ .recommendations-section-row {
    display: none;
  }

  .loadImage {
    object-fit: contain;
  }

  .product-list {
    max-width: 300px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => (props.newRecommendationEnabled || props.isNewPDPEnabled ? `margin: 0 5px` : '')}
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin: 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => (!props.isAbCartReward ? `display: flex` : '')};
    }
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .recommendation-cta {
      width: 162px;
    }
    .no-carousel-container {
      ul {
        width: 214px;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .recommendations-header {
      font-size: 14px;
      ${(props) =>
        props.isVerticalRecommendationsEnabled &&
        `font-family: Nunito;font-size: 16px;margin: 0 0px 30px 54px;font-weight: 800;`}
      ${(props) =>
        props.newRecommendationEnabled &&
        `border-top: 1px solid ${props.theme.colorPalette.gray[300]};`}
      ${(props) => props.newRecommendationEnabled && `background: none;`}
    }
    .recommendation-cta {
      width: 210px;
    }
    .no-carousel-container {
      ul {
        ${(props) => (props.isNoResponseRecommendation ? `list-style-type: none;` : '')}
        width: ${(props) => (props.isNewPDPEnabled && props.isSNJEnabled ? '233px' : '291px')};
      }
    }
    .accordion-recommendation {
      border-top: 1px solid ${(props) => props.theme.colorPalette.gray[300]};
      background: none;
    }

    .show-accordion-toggle ~ .recommendations-section-row {
      display: flex;
    }
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};

  .suggested-item {
    .item-container-inner {
      height: inherit !important;
    }
    .product-image-container {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
      @media ${(props) => props.theme.mediaQuery.large} {
        height: 369px;
      }
    }
  }
  .recommendation-hide-border {
    .item-container-inner {
      border: none;
      @media ${(props) => props.theme.mediaQuery.large} {
        margin: 0;
      }
    }
    .product-image-container {
      img {
        border-radius: 6px;
      }
    }
    .container-price {
      min-height: unset !important;
      p {
        font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
      }
    }
  }

  .recommended_products_ul {
    height: 100%;
  }
  .recommendations-container-new.search-no-result-recommendations {
    border: none;
    .item-container-inner {
      height: 100%;
    }
    .recommendations-header {
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      font-size: 16px;
      font-weight: 900;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: 0.57px;
      text-align: left;
    }
    .product-list {
      max-width: 290px;
    }
  }
  .hide-skeleton-largeDesktop {
    @media ${(props) => props.theme.mediaQuery.desktop} {
      display: ${(props) => (props.sequence === '2' ? `none` : '')};
    }
`;

export const CarouselSkeletonView = styled.div`
display: ${(props) => (props.sequence === '3' ? `none` : '')};
${(props) =>
  (props.isPDP || props.isMainView) &&
  `
@media ${props.theme.mediaQuery.large} {
  height: ${props.isMainView ? `525px;` : `540px;`};
}
@media ${props.theme.mediaQuery.mediumOnly} {
  height: ${props.isMainView ? `370px;` : `430px;`};
  margin: ${props.isPDP ? `0 15px 0 15px;` : `0`}
}
@media ${props.theme.mediaQuery.smallMax} {
  padding:${props.isPDP ? `0px 10px` : ``} !important ;
  height:  ${props.isMainView ? `370px;` : `413px;`};
  margin: ${props.isPDP ? `0 12px 0 12px;` : `0`}
}
`}
}
.header-skeleton{
  padding-top:10px;
  ${(props) =>
    props.isMainView &&
    `
    @media ${props.theme.mediaQuery.mediumOnly} {
      margin:0 0 16px 0;
    }
    @media ${props.theme.mediaQuery.smallOnly} {
      margin:0 0 16px 0;
    }
    @media ${props.theme.mediaQuery.large} {
      margin:0 0 16px 0;
    }
    `}
}
.carousel-skeleton {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  ${(props) =>
    (props.isPDP || props.isMainView) &&
    `
  @media ${props.theme.mediaQuery.large} {
    justify-content: flex-start;
    height: ${props.isMainView ? `420px;` : `497px;`};
  }
  @media ${props.theme.mediaQuery.mediumOnly} {
    height: ${props.isMainView ? `301px;` : `380px;`};
    padding-left: ${!props.isOutFitPage ? `26px` : `0;`}
    overflow: hidden;
    width: 1500px;
  }
  @media ${props.theme.mediaQuery.smallMax} {
    height: ${props.isMainView ? `293px;` : `362px;`};
  }
  `}
  ${(props) =>
    props.isBagPage &&
    `
  @media ${props.theme.mediaQuery.large} {
    justify-content: flex-end;
    ${
      props.isEmptyBag
        ? `height:${props.isRecommendationProductInfoEnabled ? `503px;` : `437px;`}`
        : `height:${props.isRecommendationProductInfoEnabled ? `316px;` : `250px;`}`
    }
}
  @media ${props.theme.mediaQuery.mediumOnly} {
    height:${props.isRecommendationProductInfoEnabled ? `368px;` : `291px;`};
    padding-left:0;
    overflow: hidden;
  }
  @media ${props.theme.mediaQuery.smallMax} {
    height:${props.isRecommendationProductInfoEnabled ? `359.5px;` : `291px;`};
  }
  `}
}
.recommendation-item-container {
  ${(props) =>
    (props.isPDP || props.isMainView) &&
    `
    @media (min-width: 1200px) and (max-width: 1439px) {
      &:last-child {
        display: none;
      }
    }
    @media ${props.theme.mediaQuery.large} {
      width: 40%;
      &.item-6{
        display: ${props.isMainView ? `none` : ''};
      }
    }
    @media ${props.theme.mediaQuery.mediumOnly} {
      padding-left:  ${props.isMainView ? `4px` : ''};
      margin-right: 16px;
    }
    @media ${props.theme.mediaQuery.smallMax} {
      margin: 0px 5px 0 0;
    }
    `}
    ${(props) =>
      props.isBagPage &&
      `
      @media ${props.theme.mediaQuery.large} {
        width:  14%;
        padding:0 8px 4px;
      }
      @media ${props.theme.mediaQuery.mediumOnly} {
        margin-right: 16px;
        width: 35%;
        &.item-4,
        &.item-5,
        &.item-6{
          display: none;
        }
    }
    @media ${props.theme.mediaQuery.smallMax} {
      margin: 0px 10px;
      width: 40%;
      &.item-3{
        width: 20%;
      }
      &.item-4,
      &.item-5,
      &.item-6{
        display: none;
      }
    }
      `}

      ${(props) =>
        props.isEmptyBag && props.isBagPage
          ? `
        @media  ${props.theme.mediaQuery.large} {
          width: 25%;
          padding:0 12px;
        }
        @media ${props.theme.mediaQuery.mediumOnly} {
          width: 35%;
          padding: 0px 6.5px;
        &.item-4{
          display: none;
        }
      }
        @media ${props.theme.mediaQuery.smallMax} {
          padding: 0px 6.5px;
          margin:0px;
          width: 40%;
          &.item-3{
            width: 20%;
          }
          &.item-4{
            display: none;
          }
      }
        `
          : ''}
}
.recommendation-itemBox {
  width: 100%;
  height: 99.5%;
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    width: ${(props) => (props.isMainView ? `173px` : '')};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    width: ${(props) => (props.isMainView ? `143px` : '')};
    margin: auto 3px;
    background-color: white;
    padding: ${(props) => (!props.isMainView ? `0px 10px` : '')};
  }
}
.carousel-item-image {
  height:60%;
  ${(props) =>
    (props.isPDP || props.isMainView) &&
    `
    margin-top: ${props.isMainView ? '' : '20px'};
    @media ${props.theme.mediaQuery.smallMax} {
      height: 166px;
    }
    @media ${props.theme.mediaQuery.mediumOnly} {
      height:161px;
      padding:  ${!props.isMainView ? `14px 12px 10px 12px;` : ''};
      margin-top: 0px;
    }
    @media ${props.theme.mediaQuery.large} {
      padding: 0px 7%;
      height: 260px;
    }
    `}
}
.carousel-item-details {
  height:40%;
  padding-top: 4px;
  margin-bottom: 4px;
  ${(props) =>
    (props.isPDP || props.isMainView) &&
    `
    @media ${props.theme.mediaQuery.smallMax} {
      height:41%;
      padding-top: 14px;
    }
    @media ${props.theme.mediaQuery.mediumOnly} {
      height:46%;
      padding: ${!props.isMainView ? `4px 12px 0px 12px` : '10px 0px 0px 0px'};
    }
    @media ${props.theme.mediaQuery.large} {
      height: 178px;
      padding: 3% 7%;
    }
    `}
}
`;

export const RecommendationUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: 48px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    margin-bottom: 30px;
  }
  > * {
    width: ${(props) => (props.snjNewPdpRecos ? '20%' : '25%')};
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: 29%;
      margin-right: 2%;
      margin-left: 2%;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 45%;
    }
    box-sizing: border-box;
  }
`;

export const RecommendationLi = styled.li`
  margin-top: 2em;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin: 0 9px 24px 9px;
  }
`;

export const RecommendationMultiUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const RecommendationMultiLi = styled.li``;

export const RecommendationMultiGridHeader = styled.div`
  border-radius: 10px;
  text-align: center;
  height: 29px;
  box-shadow: ${(props) => props.theme.colors.PRIMARY.COLOR3} 0px 18px inset;
  color: ${(props) => props.theme.colors.WHITE};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  text-transform: uppercase;
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
    box-shadow: ${(props) => props.theme.colors.PRIMARY.COLOR3} 0px 16px inset;
    height: 25px;
    border-radius: 8px;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
    height: 24px;
    box-shadow: ${(props) => props.theme.colors.PRIMARY.COLOR3} 0px 14px inset;
    border-radius: 8px;
  }
`;

export const ButtonDiv = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 48px;
`;

export const Button = styled.button`
  border: solid 1px ${(props) => props.theme.colors.TEXT.DARKERGRAY};
  background-color: ${(props) => props.theme.colors.WHITE};
  font-family: Nunito;
  font-size: 14px;
  font-weight: 800;
  color: ${(props) => props.theme.colors.PRIMARY.DARK};
  justify-content: center;
  cursor: pointer;
  min-height: 59px;
  width: 21%;
  &:focus {
    border: solid 1px ${(props) => props.theme.colors.TEXT.DARKERGRAY};
  }
  &:active {
    border: solid 1px ${(props) => props.theme.colors.TEXT.DARKERGRAY};
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    min-height: 42px;
    width: 26%;
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    min-height: 42px;
    width: 42%;
  }
`;
